import * as CheckoutEvent from './CheckoutEvent';
import * as PriceBreakdown from './PriceBreakdown';
import * as CheckoutCustomer from './CheckoutCustomer';
import * as OrderTicket from './OrderTicket';
import * as Address from './Address';
import { take } from "../util/takePayload";
export const fromGql = (gqlItem) => (Object.assign(Object.assign({}, take(gqlItem, 'fingerprint', 'state')), { customer: CheckoutCustomer.fromGQL(gqlItem.customer), event: CheckoutEvent.fromGql(gqlItem.event), breakdown: PriceBreakdown.fromGql(gqlItem.breakdown), items: gqlItem.items.map(OrderTicket.fromGql), address: gqlItem.address ? Address.fromGql(gqlItem.address) : undefined }));
//# sourceMappingURL=OrderSummary.js.map